import apiBase from "../../infra/apiBase";
import api from "../../infra/api";

class ServParam {
  async recuperarRespTecnicoParametros() {
    const response = await apiBase({
      method: "GET",
      url: "api/v1/Parametros/RespTecnicoParametros/1"
    });

    return response.data;
  }

  async recuperarParametro() {
    const response = await api({
      method: "GET",
      url: "api/v1/Parametros/GDParametros"
    });

    return response.data;
  }

  async solicitacaoVistoriaParametros() {
    const response = await api({
      method: "GET",
      url: `api/v1/Parametros/SolicitacaoVistoriaParametros`
    });

    return response.data;
  }

  async recuperarTermoConsentimento() {
    const response = await apiBase({
      method: "GET",
      url: "api/v1/Parametros/RecuperarTermoDoc/1"
    });

    return response.data;
  }

  async validarChaveApi(chaveApi) {
    const response = await api({
      method: "GET",
      url: `api/v1/Parametros/ValidarChaveApiGoogle/${chaveApi}`
    });

    return response.data;
  }

  async RecuperarDocumentosObrigatorios(etapaProcesso) {
    const response = await api({
      method: "GET",
      url: `api/v1/ConfiguracaoDocs/RecuperarDocumentosObrigatorios/${etapaProcesso}`
    });

    return response.data;
  }

  async recuperarCIParametros() {
    const response = await api({
      method: "GET",
      url: 'api/v1/Parametros/CIParametros'
    });

    return response.data;
  }

  async recuperarGDParametros() {
    const response = await api({
      method: "GET",
      url: 'api/v1/Parametros/GDParametros'
    });

    return response.data;
  }
}

export default new ServParam();
